var _toConsumableArray = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
!function webpackUniversalModuleDefinition(e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"), require("@driftt/tide-core"), require("ramda"), require("moment-timezone"), require("@driftt/tide-icons"), require("@driftt/traffic-control"), require("qs"), require("react-redux"), require("@driftt/tide-table"), require("@driftt/web-auth"));else if ("function" === typeof define && define.amd) define(["react", "@driftt/tide-core", "ramda", "moment-timezone", "@driftt/tide-icons", "@driftt/traffic-control", "qs", "react-redux", "@driftt/tide-table", "@driftt/web-auth"], t);else {
    var n = "object" === typeof exports ? t(require("react"), require("@driftt/tide-core"), require("ramda"), require("moment-timezone"), require("@driftt/tide-icons"), require("@driftt/traffic-control"), require("qs"), require("react-redux"), require("@driftt/tide-table"), require("@driftt/web-auth")) : t(e.react, e["@driftt/tide-core"], e.ramda, e["moment-timezone"], e["@driftt/tide-icons"], e["@driftt/traffic-control"], e.qs, e["react-redux"], e["@driftt/tide-table"], e["@driftt/web-auth"]);
    for (var r in n) {
      ("object" === typeof exports ? exports : e)[r] = n[r];
    }
  }
}(window, function (e, t, n, r, a, o, i, s, c, l) {
  return function (e) {
    var t = {};
    function __webpack_require__(n) {
      if (t[n]) return t[n].exports;
      var r = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(r.exports, r, r.exports, __webpack_require__), r.l = !0, r.exports;
    }
    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, n) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        __webpack_require__.d(n, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return n;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 16);
  }([function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t) {
    e.exports = n;
  }, function (e, t) {
    e.exports = r;
  }, function (e, t) {
    e.exports = a;
  }, function (e, t) {
    e.exports = o;
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      var t = [];
      return t.toString = function toString() {
        return this.map(function (t) {
          var n = function cssWithMappingToString(e, t) {
            var n = e[1] || "",
              r = e[3];
            if (!r) return n;
            if (t && "function" === typeof btoa) {
              var a = function toComment(e) {
                  return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
                }(r),
                o = r.sources.map(function (e) {
                  return "/*# sourceURL=" + r.sourceRoot + e + " */";
                });
              return [n].concat(o).concat([a]).join("\n");
            }
            return [n].join("\n");
          }(t, e);
          return t[2] ? "@media " + t[2] + "{" + n + "}" : n;
        }).join("");
      }, t.i = function (e, n) {
        "string" === typeof e && (e = [[null, e, ""]]);
        for (var r = {}, a = 0; a < this.length; a++) {
          var o = this[a][0];
          null != o && (r[o] = !0);
        }
        for (a = 0; a < e.length; a++) {
          var i = e[a];
          null != i[0] && r[i[0]] || (n && !i[2] ? i[2] = n : n && (i[2] = "(" + i[2] + ") and (" + n + ")"), t.push(i));
        }
      }, t;
    };
  }, function (e, t, n) {
    "use strict";

    var r = {},
      a = function isOldIE() {
        var e;
        return function memorize() {
          return "undefined" === typeof e && (e = Boolean(window && document && document.all && !window.atob)), e;
        };
      }(),
      o = function getTarget() {
        var e = {};
        return function memorize(t) {
          if ("undefined" === typeof e[t]) {
            var n = document.querySelector(t);
            if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
              n = n.contentDocument.head;
            } catch (r) {
              n = null;
            }
            e[t] = n;
          }
          return e[t];
        };
      }();
    function listToStyles(e, t) {
      for (var n = [], r = {}, a = 0; a < e.length; a++) {
        var o = e[a],
          i = t.base ? o[0] + t.base : o[0],
          s = {
            css: o[1],
            media: o[2],
            sourceMap: o[3]
          };
        r[i] ? r[i].parts.push(s) : n.push(r[i] = {
          id: i,
          parts: [s]
        });
      }
      return n;
    }
    function addStylesToDom(e, t) {
      for (var n = 0; n < e.length; n++) {
        var a = e[n],
          o = r[a.id],
          i = 0;
        if (o) {
          for (o.refs++; i < o.parts.length; i++) {
            o.parts[i](a.parts[i]);
          }
          for (; i < a.parts.length; i++) {
            o.parts.push(addStyle(a.parts[i], t));
          }
        } else {
          for (var s = []; i < a.parts.length; i++) {
            s.push(addStyle(a.parts[i], t));
          }
          r[a.id] = {
            id: a.id,
            refs: 1,
            parts: s
          };
        }
      }
    }
    function insertStyleElement(e) {
      var t = document.createElement("style");
      if ("undefined" === typeof e.attributes.nonce) {
        var r = n.nc;
        r && (e.attributes.nonce = r);
      }
      if (Object.keys(e.attributes).forEach(function (n) {
        t.setAttribute(n, e.attributes[n]);
      }), "function" === typeof e.insert) e.insert(t);else {
        var a = o(e.insert || "head");
        if (!a) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        a.appendChild(t);
      }
      return t;
    }
    var i = function replaceText() {
      var e = [];
      return function replace(t, n) {
        return e[t] = n, e.filter(Boolean).join("\n");
      };
    }();
    function applyToSingletonTag(e, t, n, r) {
      var a = n ? "" : r.css;
      if (e.styleSheet) e.styleSheet.cssText = i(t, a);else {
        var o = document.createTextNode(a),
          s = e.childNodes;
        s[t] && e.removeChild(s[t]), s.length ? e.insertBefore(o, s[t]) : e.appendChild(o);
      }
    }
    var s = null,
      c = 0;
    function addStyle(e, t) {
      var n, r, a;
      if (t.singleton) {
        var o = c++;
        n = s || (s = insertStyleElement(t)), r = applyToSingletonTag.bind(null, n, o, !1), a = applyToSingletonTag.bind(null, n, o, !0);
      } else n = insertStyleElement(t), r = function applyToTag(e, t, n) {
        var r = n.css,
          a = n.media,
          o = n.sourceMap;
        if (a && e.setAttribute("media", a), o && btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), e.styleSheet) e.styleSheet.cssText = r;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }
          e.appendChild(document.createTextNode(r));
        }
      }.bind(null, n, t), a = function remove() {
        !function removeStyleElement(e) {
          if (null === e.parentNode) return !1;
          e.parentNode.removeChild(e);
        }(n);
      };
      return r(e), function updateStyle(t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          r(e = t);
        } else a();
      };
    }
    e.exports = function (e, t) {
      (t = t || {}).attributes = "object" === typeof t.attributes ? t.attributes : {}, t.singleton || "boolean" === typeof t.singleton || (t.singleton = a());
      var n = listToStyles(e, t);
      return addStylesToDom(n, t), function update(e) {
        for (var a = [], o = 0; o < n.length; o++) {
          var i = n[o],
            s = r[i.id];
          s && (s.refs--, a.push(s));
        }
        e && addStylesToDom(listToStyles(e, t), t);
        for (var c = 0; c < a.length; c++) {
          var l = a[c];
          if (0 === l.refs) {
            for (var u = 0; u < l.parts.length; u++) {
              l.parts[u]();
            }
            delete r[l.id];
          }
        }
      };
    };
  }, function (e, t, n) {
    e.exports = n(17);
  }, function (e, t) {
    e.exports = i;
  }, function (e, t) {
    e.exports = s;
  }, function (e, t) {
    e.exports = c;
  }, function (e, t) {
    e.exports = l;
  }, function (e) {
    e.exports = {
      REDUX_ACTION_NAMESPACE: "__insights-components",
      AUTH_CLIENT_ID: "AUTH_CLIENT_ID"
    };
  }, function (e) {
    e.exports = {
      REDUX_ACTION_NAMESPACE: "__insights-components",
      AUTH_CLIENT_ID: "AUTH_CLIENT_ID"
    };
  }, function (e) {
    e.exports = {
      REDUX_ACTION_NAMESPACE: "__insights-components",
      AUTH_CLIENT_ID: "AUTH_CLIENT_ID"
    };
  }, function (e, t, n) {
    e.exports = n(32);
  }, function (e, t, n) {
    var r = function (e) {
      "use strict";

      var t,
        n = Object.prototype,
        r = n.hasOwnProperty,
        a = "function" === typeof Symbol ? Symbol : {},
        o = a.iterator || "@@iterator",
        i = a.asyncIterator || "@@asyncIterator",
        s = a.toStringTag || "@@toStringTag";
      function wrap(e, t, n, r) {
        var a = t && t.prototype instanceof Generator ? t : Generator,
          o = Object.create(a.prototype),
          i = new Context(r || []);
        return o._invoke = function makeInvokeMethod(e, t, n) {
          var r = c;
          return function invoke(a, o) {
            if (r === u) throw new Error("Generator is already running");
            if (r === m) {
              if ("throw" === a) throw o;
              return doneResult();
            }
            for (n.method = a, n.arg = o;;) {
              var i = n.delegate;
              if (i) {
                var s = maybeInvokeDelegate(i, n);
                if (s) {
                  if (s === d) continue;
                  return s;
                }
              }
              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if (r === c) throw r = m, n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              r = u;
              var p = tryCatch(e, t, n);
              if ("normal" === p.type) {
                if (r = n.done ? m : l, p.arg === d) continue;
                return {
                  value: p.arg,
                  done: n.done
                };
              }
              "throw" === p.type && (r = m, n.method = "throw", n.arg = p.arg);
            }
          };
        }(e, n, i), o;
      }
      function tryCatch(e, t, n) {
        try {
          return {
            type: "normal",
            arg: e.call(t, n)
          };
        } catch (r) {
          return {
            type: "throw",
            arg: r
          };
        }
      }
      e.wrap = wrap;
      var c = "suspendedStart",
        l = "suspendedYield",
        u = "executing",
        m = "completed",
        d = {};
      function Generator() {}
      function GeneratorFunction() {}
      function GeneratorFunctionPrototype() {}
      var p = {};
      p[o] = function () {
        return this;
      };
      var A = Object.getPrototypeOf,
        f = A && A(A(values([])));
      f && f !== n && r.call(f, o) && (p = f);
      var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
      function defineIteratorMethods(e) {
        ["next", "throw", "return"].forEach(function (t) {
          e[t] = function (e) {
            return this._invoke(t, e);
          };
        });
      }
      function AsyncIterator(e, t) {
        var n;
        this._invoke = function enqueue(a, o) {
          function callInvokeWithMethodAndArg() {
            return new t(function (n, i) {
              !function invoke(n, a, o, i) {
                var s = tryCatch(e[n], e, a);
                if ("throw" !== s.type) {
                  var c = s.arg,
                    l = c.value;
                  return l && "object" === typeof l && r.call(l, "__await") ? t.resolve(l.__await).then(function (e) {
                    invoke("next", e, o, i);
                  }, function (e) {
                    invoke("throw", e, o, i);
                  }) : t.resolve(l).then(function (e) {
                    c.value = e, o(c);
                  }, function (e) {
                    return invoke("throw", e, o, i);
                  });
                }
                i(s.arg);
              }(a, o, n, i);
            });
          }
          return n = n ? n.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
      }
      function maybeInvokeDelegate(e, n) {
        var r = e.iterator[n.method];
        if (r === t) {
          if (n.delegate = null, "throw" === n.method) {
            if (e.iterator.return && (n.method = "return", n.arg = t, maybeInvokeDelegate(e, n), "throw" === n.method)) return d;
            n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return d;
        }
        var a = tryCatch(r, e.iterator, n.arg);
        if ("throw" === a.type) return n.method = "throw", n.arg = a.arg, n.delegate = null, d;
        var o = a.arg;
        return o ? o.done ? (n[e.resultName] = o.value, n.next = e.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, d) : o : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, d);
      }
      function pushTryEntry(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }
      function resetTryEntry(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }
      function Context(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(pushTryEntry, this), this.reset(!0);
      }
      function values(e) {
        if (e) {
          var n = e[o];
          if (n) return n.call(e);
          if ("function" === typeof e.next) return e;
          if (!isNaN(e.length)) {
            var a = -1,
              i = function next() {
                for (; ++a < e.length;) {
                  if (r.call(e, a)) return next.value = e[a], next.done = !1, next;
                }
                return next.value = t, next.done = !0, next;
              };
            return i.next = i;
          }
        }
        return {
          next: doneResult
        };
      }
      function doneResult() {
        return {
          value: t,
          done: !0
        };
      }
      return GeneratorFunction.prototype = g.constructor = GeneratorFunctionPrototype, GeneratorFunctionPrototype.constructor = GeneratorFunction, GeneratorFunctionPrototype[s] = GeneratorFunction.displayName = "GeneratorFunction", e.isGeneratorFunction = function (e) {
        var t = "function" === typeof e && e.constructor;
        return !!t && (t === GeneratorFunction || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, s in e || (e[s] = "GeneratorFunction")), e.prototype = Object.create(g), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, defineIteratorMethods(AsyncIterator.prototype), AsyncIterator.prototype[i] = function () {
        return this;
      }, e.AsyncIterator = AsyncIterator, e.async = function (t, n, r, a, o) {
        void 0 === o && (o = Promise);
        var i = new AsyncIterator(wrap(t, n, r, a), o);
        return e.isGeneratorFunction(n) ? i : i.next().then(function (e) {
          return e.done ? e.value : i.next();
        });
      }, defineIteratorMethods(g), g[s] = "Generator", g[o] = function () {
        return this;
      }, g.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var t = [];
        for (var n in e) {
          t.push(n);
        }
        return t.reverse(), function next() {
          for (; t.length;) {
            var n = t.pop();
            if (n in e) return next.value = n, next.done = !1, next;
          }
          return next.done = !0, next;
        };
      }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var n in this) {
            "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var n = this;
          function handle(r, a) {
            return i.type = "throw", i.arg = e, n.next = r, a && (n.method = "next", n.arg = t), !!a;
          }
          for (var a = this.tryEntries.length - 1; a >= 0; --a) {
            var o = this.tryEntries[a],
              i = o.completion;
            if ("root" === o.tryLoc) return handle("end");
            if (o.tryLoc <= this.prev) {
              var s = r.call(o, "catchLoc"),
                c = r.call(o, "finallyLoc");
              if (s && c) {
                if (this.prev < o.catchLoc) return handle(o.catchLoc, !0);
                if (this.prev < o.finallyLoc) return handle(o.finallyLoc);
              } else if (s) {
                if (this.prev < o.catchLoc) return handle(o.catchLoc, !0);
              } else {
                if (!c) throw new Error("try statement without catch or finally");
                if (this.prev < o.finallyLoc) return handle(o.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var a = this.tryEntries[n];
            if (a.tryLoc <= this.prev && r.call(a, "finallyLoc") && this.prev < a.finallyLoc) {
              var o = a;
              break;
            }
          }
          o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
          var i = o ? o.completion : {};
          return i.type = e, i.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(i);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), d;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), resetTryEntry(n), d;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.tryLoc === e) {
              var r = n.completion;
              if ("throw" === r.type) {
                var a = r.arg;
                resetTryEntry(n);
              }
              return a;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, n, r) {
          return this.delegate = {
            iterator: values(e),
            resultName: n,
            nextLoc: r
          }, "next" === this.method && (this.arg = t), d;
        }
      }, e;
    }(e.exports);
    try {
      regeneratorRuntime = r;
    } catch (a) {
      Function("r", "regeneratorRuntime = r")(r);
    }
  }, function (e, t, n) {
    var r = n(19);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var a = {
      insert: "head",
      singleton: !1
    };
    n(7)(r, a);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(6)(!0)).push([e.i, ".message-item-text {\n  word-break: break-word;\n  margin: 0;\n}\n\n.message-item-text--highlight {\n  background-color: var(--color-p3-4);\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mCAAmC;AACrC",
      file: "styles.css",
      sourcesContent: [".message-item-text {\n  word-break: break-word;\n  margin: 0;\n}\n\n.message-item-text--highlight {\n  background-color: var(--color-p3-4);\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(21);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var a = {
      insert: "head",
      singleton: !1
    };
    n(7)(r, a);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(6)(!0)).push([e.i, ".colored-bolt.tide-icon path {\n    stroke: #f6c12d;\n    fill: #fff2cc;\n  }\n.colored-minus.tide-icon path {\nstroke: #f85346;\nstroke-width: 2px;\nfill: #ffc2bd;\n}", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;IACI,eAAe;IACf,aAAa;EACf;AACF;AACA,eAAe;AACf,iBAAiB;AACjB,aAAa;AACb",
      file: "styles.css",
      sourcesContent: [".colored-bolt.tide-icon path {\n    stroke: #f6c12d;\n    fill: #fff2cc;\n  }\n.colored-minus.tide-icon path {\nstroke: #f85346;\nstroke-width: 2px;\nfill: #ffc2bd;\n}"]
    }]);
  }, function (e, t, n) {
    var r = n(23);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var a = {
      insert: "head",
      singleton: !1
    };
    n(7)(r, a);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(6)(!0)).push([e.i, ".results-list-item--container {\n  padding: 0 24px 0 24px;\n}\n\n.results-list-item--container--clickable {\n  cursor: pointer;\n}\n\n.results-list-item--container:hover {\n  background-color: var(--color-p3-2);\n}\n\n.results-list-item--container:last-child .results-list-item {\n  border-bottom: none;\n}\n\n.results-list-item {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  padding-bottom: 16px;\n  padding-top: 16px;\n  border-bottom: 1px solid #e7ebee;\n  align-items: center;\n}\n\n.results-list-item-company-logo {\n  max-height: 32px;\n  max-width: 32px;\n}\n\n.results-list-item-body {\n  padding-left: 16px;\n}\n\n.result-list-item--link {\n  text-decoration: none;\n}\n\n.result-list-item--link:hover {\n  text-decoration: underline;\n  -webkit-text-decoration-color: var(--color-p1-10);\n          text-decoration-color: var(--color-p1-10);\n}\n\n.results-list-item-title-info {\n  display: grid;\n  grid-template-columns: auto auto 1fr;\n  grid-column-gap: 8px;\n  -webkit-column-gap: 8px;\n          column-gap: 8px;\n  align-items: center;\n}\n\n.results-list-item-title-container {\n  margin-top: 0;\n}\n\n.result-list-item-message-count {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-column-gap: 4px;\n  -webkit-column-gap: 4px;\n          column-gap: 4px;\n}\n\n.result-list-item-message-count p {\n  margin: 0;\n}\n\n.results-list-item-subtitle {\n  color: var(--color-p1-7);\n  font-size: 12px;\n  font-family: var(--main-font-family);\n}\n\n.results-list-item-arrow-icon path {\n  fill: var(--color-p1-6);\n}\n\n.results-list-item-tags .tide-tag {\n  margin-top: 10px;\n}\n\n.results-list-item-arrow > svg {\n  height: 100%;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,oBAAoB;EACpB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,iDAAyC;UAAzC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,oBAAe;EAAf,uBAAe;UAAf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,oBAAe;EAAf,uBAAe;UAAf,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd",
      file: "styles.css",
      sourcesContent: [".results-list-item--container {\n  padding: 0 24px 0 24px;\n}\n\n.results-list-item--container--clickable {\n  cursor: pointer;\n}\n\n.results-list-item--container:hover {\n  background-color: var(--color-p3-2);\n}\n\n.results-list-item--container:last-child .results-list-item {\n  border-bottom: none;\n}\n\n.results-list-item {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  padding-bottom: 16px;\n  padding-top: 16px;\n  border-bottom: 1px solid #e7ebee;\n  align-items: center;\n}\n\n.results-list-item-company-logo {\n  max-height: 32px;\n  max-width: 32px;\n}\n\n.results-list-item-body {\n  padding-left: 16px;\n}\n\n.result-list-item--link {\n  text-decoration: none;\n}\n\n.result-list-item--link:hover {\n  text-decoration: underline;\n  text-decoration-color: var(--color-p1-10);\n}\n\n.results-list-item-title-info {\n  display: grid;\n  grid-template-columns: auto auto 1fr;\n  column-gap: 8px;\n  align-items: center;\n}\n\n.results-list-item-title-container {\n  margin-top: 0;\n}\n\n.result-list-item-message-count {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  column-gap: 4px;\n}\n\n.result-list-item-message-count p {\n  margin: 0;\n}\n\n.results-list-item-subtitle {\n  color: var(--color-p1-7);\n  font-size: 12px;\n  font-family: var(--main-font-family);\n}\n\n.results-list-item-arrow-icon path {\n  fill: var(--color-p1-6);\n}\n\n.results-list-item-tags .tide-tag {\n  margin-top: 10px;\n}\n\n.results-list-item-arrow > svg {\n  height: 100%;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(25);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var a = {
      insert: "head",
      singleton: !1
    };
    n(7)(r, a);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(6)(!0)).push([e.i, ".insights--no-results-container {\n  display: grid;\n  justify-items: center;\n  align-self: center;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB",
      file: "style.css",
      sourcesContent: [".insights--no-results-container {\n  display: grid;\n  justify-items: center;\n  align-self: center;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(27);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var a = {
      insert: "head",
      singleton: !1
    };
    n(7)(r, a);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(6)(!0)).push([e.i, ".convo-detail-message-item-container {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  margin-bottom: 17px;\n}\n\n.convo-detail-message-item-container:last-child {\n  margin-bottom: 0;\n}\n\n.convo-detail--company-logo {\n  height: 32px;\n  width: 32px;\n}\n\n.convo-detail-message-item-contents {\n  margin-left: 17px;\n}\n\n.convo-detail-message-item-name-time {\n  display: grid;\n  grid-template-columns: auto 1fr;\n}\n\n.convo-detail-message-item-name {\n  margin-top: 0;\n  margin-right: 10px;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB",
      file: "styles.css",
      sourcesContent: [".convo-detail-message-item-container {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  margin-bottom: 17px;\n}\n\n.convo-detail-message-item-container:last-child {\n  margin-bottom: 0;\n}\n\n.convo-detail--company-logo {\n  height: 32px;\n  width: 32px;\n}\n\n.convo-detail-message-item-contents {\n  margin-left: 17px;\n}\n\n.convo-detail-message-item-name-time {\n  display: grid;\n  grid-template-columns: auto 1fr;\n}\n\n.convo-detail-message-item-name {\n  margin-top: 0;\n  margin-right: 10px;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(29);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var a = {
      insert: "head",
      singleton: !1
    };
    n(7)(r, a);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(6)(!0)).push([e.i, ".new-conversation-detail {\n  height: 100%;\n}\n\n.new-conversation-detail--loading-spinner {\n  margin: 32px auto;\n}\n\n.new-conversation-detail--conversation-container {\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n  height: 100%;\n}\n\n.new-conversation-detail--header {\n  padding: 16px 16px 8px 16px;\n  border-bottom: 1px solid var(--color-p1-5);\n  background-color: var(--color-p1-2);\n}\n\n.new-conversation-detail--header > p {\n  margin: 0;\n}\n\n.new-conversation-detail--name-cql {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  grid-column-gap: 8px;\n  -webkit-column-gap: 8px;\n          column-gap: 8px;\n}\n\n.new-conversation-detail--name-cql > h2 {\n  margin: 0;\n}\n\n.new-conversation-detail--message-container {\n  padding: 16px;\n  overflow-y: auto;\n}\n\n.new-conversation-detail--button-container {\n  padding: 16px;\n  border-top: 1px solid var(--color-p1-5);\n  display: grid;\n  grid-template-columns: auto auto 1fr;\n  grid-column-gap: 8px;\n  -webkit-column-gap: 8px;\n          column-gap: 8px;\n}\n\n.new-conversation-detail--no-conversation-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  text-align: center;\n  padding: 0 32px;\n}\n\n.conversation-not-found-colorways-container {\n  display: flex;\n  justify-content: center;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,oBAAe;EAAf,uBAAe;UAAf,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,aAAa;EACb,oCAAoC;EACpC,oBAAe;EAAf,uBAAe;UAAf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB",
      file: "styles.css",
      sourcesContent: [".new-conversation-detail {\n  height: 100%;\n}\n\n.new-conversation-detail--loading-spinner {\n  margin: 32px auto;\n}\n\n.new-conversation-detail--conversation-container {\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n  height: 100%;\n}\n\n.new-conversation-detail--header {\n  padding: 16px 16px 8px 16px;\n  border-bottom: 1px solid var(--color-p1-5);\n  background-color: var(--color-p1-2);\n}\n\n.new-conversation-detail--header > p {\n  margin: 0;\n}\n\n.new-conversation-detail--name-cql {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  column-gap: 8px;\n}\n\n.new-conversation-detail--name-cql > h2 {\n  margin: 0;\n}\n\n.new-conversation-detail--message-container {\n  padding: 16px;\n  overflow-y: auto;\n}\n\n.new-conversation-detail--button-container {\n  padding: 16px;\n  border-top: 1px solid var(--color-p1-5);\n  display: grid;\n  grid-template-columns: auto auto 1fr;\n  column-gap: 8px;\n}\n\n.new-conversation-detail--no-conversation-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  text-align: center;\n  padding: 0 32px;\n}\n\n.conversation-not-found-colorways-container {\n  display: flex;\n  justify-content: center;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(31);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var a = {
      insert: "head",
      singleton: !1
    };
    n(7)(r, a);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(6)(!0)).push([e.i, ".insights--conversations-container {\n  width: 100%;\n}\n\n.insights--conversations-loader {\n  margin: 96px auto;\n  align-self: center;\n}\n\n.insights--conversations-drawer-container {\n  width: 480px;\n  display: flex;\n  flex-direction: column;\n}\n\n.insights--drawer-content {\n  flex: 1 1;\n  overflow: auto;\n}\n\n.insights--drawer-content-results {\n  display: grid;\n  grid-template-rows: 1fr auto;\n  height: 100%;\n}\n\n.insights--drawer-content-results .results-list {\n  overflow-y: auto;\n  height: 100%;\n}\n\n.insights--drawer-content-results .results-list--paginator {\n  padding: 16px 24px;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB",
      file: "style.css",
      sourcesContent: [".insights--conversations-container {\n  width: 100%;\n}\n\n.insights--conversations-loader {\n  margin: 96px auto;\n  align-self: center;\n}\n\n.insights--conversations-drawer-container {\n  width: 480px;\n  display: flex;\n  flex-direction: column;\n}\n\n.insights--drawer-content {\n  flex: 1;\n  overflow: auto;\n}\n\n.insights--drawer-content-results {\n  display: grid;\n  grid-template-rows: 1fr auto;\n  height: 100%;\n}\n\n.insights--drawer-content-results .results-list {\n  overflow-y: auto;\n  height: 100%;\n}\n\n.insights--drawer-content-results .results-list--paginator {\n  padding: 16px 24px;\n}\n"]
    }]);
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(8),
      a = n.n(r);
    function asyncGeneratorStep(e, t, n, r, a, o, i) {
      try {
        var s = e[o](i),
          c = s.value;
      } catch (l) {
        return void n(l);
      }
      s.done ? t(c) : Promise.resolve(c).then(r, a);
    }
    function _asyncToGenerator(e) {
      return function () {
        var t = this,
          n = arguments;
        return new Promise(function (r, a) {
          var o = e.apply(t, n);
          function _next(e) {
            asyncGeneratorStep(o, r, a, _next, _throw, "next", e);
          }
          function _throw(e) {
            asyncGeneratorStep(o, r, a, _next, _throw, "throw", e);
          }
          _next(void 0);
        });
      };
    }
    function _arrayLikeToArray(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }
      return r;
    }
    function _slicedToArray(e, t) {
      return function _arrayWithHoles(e) {
        if (Array.isArray(e)) return e;
      }(e) || function _iterableToArrayLimit(e, t) {
        if ("undefined" !== typeof Symbol && Symbol.iterator in Object(e)) {
          var n = [],
            r = !0,
            a = !1,
            o = void 0;
          try {
            for (var i, s = e[Symbol.iterator](); !(r = (i = s.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
              ;
            }
          } catch (c) {
            a = !0, o = c;
          } finally {
            try {
              r || null == s.return || s.return();
            } finally {
              if (a) throw o;
            }
          }
          return n;
        }
      }(e, t) || function _unsupportedIterableToArray(e, t) {
        if (e) {
          if ("string" === typeof e) return _arrayLikeToArray(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(n) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray(e, t) : void 0;
        }
      }(e, t) || function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function _objectWithoutProperties(e, t) {
      if (null == e) return {};
      var n,
        r,
        a = function _objectWithoutPropertiesLoose(e, t) {
          if (null == e) return {};
          var n,
            r,
            a = {},
            o = Object.keys(e);
          for (r = 0; r < o.length; r++) {
            n = o[r], t.indexOf(n) >= 0 || (a[n] = e[n]);
          }
          return a;
        }(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (r = 0; r < o.length; r++) {
          n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (a[n] = e[n]);
        }
      }
      return a;
    }
    var o = n(3),
      i = n.n(o),
      s = n(2),
      c = n(0),
      l = n.n(c),
      u = n(10);
    function useDeepCompareMemoize(e) {
      var t = l.a.useRef();
      return function dequal(e, t) {
        var n, r;
        if (e === t) return !0;
        if (e && t && (n = e.constructor) === t.constructor) {
          if (n === Date) return e.getTime() === t.getTime();
          if (n === RegExp) return e.toString() === t.toString();
          if (n === Array && (r = e.length) === t.length) {
            for (; r-- && dequal(e[r], t[r]);) {
              ;
            }
            return -1 === r;
          }
          if (n === Object) {
            if (Object.keys(e).length !== Object.keys(t).length) return !1;
            for (r in e) {
              if (!(r in t) || !dequal(e[r], t[r])) return !1;
            }
            return !0;
          }
        }
        return e !== e && t !== t;
      }(e, t.current) || (t.current = e), t.current;
    }
    var m = function useDeepCompareEffect(e, t) {
        l.a.useEffect(e, useDeepCompareMemoize(t));
      },
      d = n(1),
      p = n(11),
      A = n(5),
      f = n(4);
    function miniHash(e, t) {
      var n,
        r,
        a = 0;
      if (!e) return a;
      if (0 === e.length) return a;
      for (n = 0; n < e.length; n++) {
        a = (a << 5) - a + (r = e.charCodeAt(n)), a |= 0;
      }
      return t ? a : Math.abs(a);
    }
    n(18);
    var g = function g(_ref) {
      var e = _ref.message.basic.body,
        t = _ref.keywords;
      var n = e;
      return t.forEach(function (e) {
        var t = n.toLowerCase().indexOf(e.toLowerCase()),
          r = t + e.length;
        -1 !== t && (n = "".concat(n.slice(0, t), '\n      <span class="message-item-text--highlight">').concat(n.slice(t, r), "</span>\n      ").concat(n.slice(r)));
      }), l.a.createElement(d.P, {
        type: "small",
        className: "message-item-text",
        dangerouslySetInnerHTML: {
          __html: n
        }
      });
    };
    var h = {
      Alabama: "AL",
      Alaska: "AK",
      "American Samoa": "AS",
      Arizona: "AZ",
      Arkansas: "AR",
      California: "CA",
      Colorado: "CO",
      Connecticut: "CT",
      Delaware: "DE",
      "District Of Columbia": "DC",
      "Federated States Of Micronesia": "FM",
      Florida: "FL",
      Georgia: "GA",
      Guam: "GU",
      Hawaii: "HI",
      Idaho: "ID",
      Illinois: "IL",
      Indiana: "IN",
      Iowa: "IA",
      Kansas: "KS",
      Kentucky: "KY",
      Louisiana: "LA",
      Maine: "ME",
      "Marshall Islands": "MH",
      Maryland: "MD",
      Massachusetts: "MA",
      Michigan: "MI",
      Minnesota: "MN",
      Mississippi: "MS",
      Missouri: "MO",
      Montana: "MT",
      Nebraska: "NE",
      Nevada: "NV",
      "New Hampshire": "NH",
      "New Jersey": "NJ",
      "New Mexico": "NM",
      "New York": "NY",
      "North Carolina": "NC",
      "North Dakota": "ND",
      "Northern Mariana Islands": "MP",
      Ohio: "OH",
      Oklahoma: "OK",
      Oregon: "OR",
      Palau: "PW",
      Pennsylvania: "PA",
      "Puerto Rico": "PR",
      "Rhode Island": "RI",
      "South Carolina": "SC",
      "South Dakota": "SD",
      Tennessee: "TN",
      Texas: "TX",
      Utah: "UT",
      Vermont: "VT",
      "Virgin Islands": "VI",
      Virginia: "VA",
      Washington: "WA",
      "West Virginia": "WV",
      Wisconsin: "WI",
      Wyoming: "WY"
    };
    var y = function y(e) {
      if (Object(s.isEmpty)(e)) return "";
      var t = e.city,
        n = e.region,
        r = e.country;
      return "".concat(t && "".concat(t, ","), " ").concat(n && h[n] && h[n] || r && r);
    };
    n(20);
    var v = function v(e) {
      var t = l.a.createElement(f.Icon, {
        className: "colored-minus",
        name: "minus",
        width: 16,
        height: "16px"
      });
      return -1 === e ? t : function (e) {
        return l.a.createElement(d.Span, null, Array(e).fill(null).map(function (e, t) {
          return function (e) {
            return l.a.createElement(f.Icon, {
              className: "colored-bolt",
              name: "lightning-bolt-filled",
              key: e
            });
          }(t);
        }));
      }(e);
    };
    n(22);
    var E = function E(_ref2) {
      var e = _ref2.conversation,
        t = _ref2.keywords,
        n = _ref2.setSelectedConversation;
      var r = e.matchedMessages,
        a = e.customer,
        o = e.meta,
        s = a.email,
        c = a.name,
        u = o.newestMessageAt,
        m = o.location,
        p = o.company,
        A = o.messageCount,
        h = o.cqlRating,
        E = [].concat(_toConsumableArray(t.customer || []), _toConsumableArray(t.any || []), _toConsumableArray(t.agent || []));
      return l.a.createElement(d.Div, {
        className: "results-list-item--container results-list-item--container--clickable",
        onClick: function onClick() {
          return n(e.conversationId);
        }
      }, l.a.createElement(d.Div, {
        className: "results-list-item"
      }, p && p.logo && "null" !== p.logo ? l.a.createElement("img", {
        className: "results-list-item-company-logo",
        src: p.logo,
        alt: ""
      }) : l.a.createElement(d.Avatar, {
        user: {
          email: s,
          name: c || "Site visitor",
          id: miniHash(s || c || "Site visitor", !0)
        }
      }), l.a.createElement(d.Div, {
        className: "results-list-item-body"
      }, l.a.createElement(d.Div, null, l.a.createElement(d.Div, {
        className: "results-list-item-title-info"
      }, l.a.createElement(d.H4, {
        className: "results-list-item-title-container"
      }, l.a.createElement("span", null, c || s || "Site visitor"), p && p.name && l.a.createElement("span", null, " (".concat(p.name, ")"))), 0 !== h && v(h), l.a.createElement(d.Div, {
        className: "result-list-item-message-count"
      }, l.a.createElement(f.Icon, {
        name: "comment-1",
        width: "16",
        height: "16"
      }), l.a.createElement(d.P, {
        type: "small"
      }, A))), l.a.createElement(d.Div, {
        className: "results-list-item-subtitle"
      }, u && i()(u).format("LT \n\u2022 M/DD/YY"), m && " \n\u2022 ".concat(y(m)))), r.map(function (e) {
        return l.a.createElement(g, {
          key: e.author.messageId,
          message: e,
          keywords: E
        });
      })), l.a.createElement(f.Icon, {
        name: "arrow-1-right",
        width: 10,
        height: 16,
        className: "results-list-item-arrow-icon"
      })));
    };
    var b = function b(_ref3) {
      var e = _ref3.keywords,
        t = _ref3.results,
        n = _ref3.setSelectedConversation;
      return l.a.createElement(d.Div, {
        className: "results-list"
      }, t && t.map(function (t) {
        return l.a.createElement(E, {
          key: t.conversationId,
          keywords: e,
          conversation: t,
          setSelectedConversation: n
        });
      }));
    };
    function buildQuery(e, t) {
      var n = t.meetingBooked,
        r = t.urlHostPaths,
        a = t.playbookNames,
        o = t.playbookIds,
        i = t.agentNames,
        c = t.urlQueryParams,
        l = t.cqlRatings,
        u = t.companies,
        m = t.messageCountRange,
        d = t.tags,
        p = t.emailCaptured,
        A = Object(s.pickBy)(function (e) {
          return !Object(s.isNil)(e) && (!Array.isArray(e) || e.length > 0);
        }, {
          urlHostPaths: r,
          playbookNames: a,
          playbookIds: o,
          agentNames: i,
          urlQueryParams: c,
          cqlRatings: l,
          companies: u,
          tags: d
        });
      return n && (A.meetingBooked = n), p && (A.emailCaptured = p), m && !Object(s.isEmpty)(m) && (A.messageCountRange = m), e.forEach(function (e) {
        e.keywords.length < 1 || ("all" === e.target ? A.any ? A.any = A.any.concat(e.keywords) : A.any = e.keywords : "agent" === e.target ? A.agent ? A.any = A.agent.concat(e.keywords) : A.agent = e.keywords : "visitor" === e.target && (A.customer ? A.any = A.customer.concat(e.keywords) : A.customer = e.keywords));
      }), A;
    }
    var C = n(12);
    function _defineProperty(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function ownKeys(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function _objectSpread2(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ownKeys(Object(n), !0).forEach(function (t) {
          _defineProperty(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    var w = n(13),
      x = n(14);
    var _ = {
      QA: n(15),
      EU: w,
      US: x
    };
    var k = _objectSpread2(_objectSpread2({}, window.DRIFT_CONFIG || {}), _[window.DRIFT_REGION || ("PRODUCTION" === window.__ENV__ ? "US" : "QA")]);
    var B = Object(C.createAuthedHttpClient)({
      baseConfig: {
        baseURL: k.INSIGHTS_API
      }
    });
    n(9);
    var S = function S(e, t, n, r, a, o, s) {
        return B.post("/conv/".concat(e, "/filter"), {
          keywords: (n.agent || n.any || n.customer) && {
            agent: n.agent && {
              keywords: n.agent
            },
            any: n.any && {
              keywords: n.any
            },
            customer: n.customer && {
              keywords: n.customer
            }
          },
          date: {
            from: i()(o).tz(t).startOf("day").utc().toISOString(),
            to: i()(s).tz(t).endOf("day").utc().toISOString()
          },
          tags: n.tags && n.tags,
          companies: n.companies && n.companies,
          cqlRatings: n.cqlRatings,
          messageCountRange: n.messageCountRange,
          paginate: (a || r) && {
            offset: a,
            limit: r
          },
          urlHostPaths: n.urlHostPaths && n.urlHostPaths,
          playbookNames: n.playbookNames && n.playbookNames,
          playbookIds: n.playbookIds && n.playbookIds,
          urlQueryParams: n.urlQueryParams && n.urlQueryParams,
          aggregations: n.aggregations,
          meetingBooked: n.meetingBooked && n.meetingBooked,
          agentNames: n.agentNames && n.agentNames,
          emailCaptured: n.emailCaptured && n.emailCaptured
        });
      },
      O = function O(e, t) {
        return B.get("/conv/".concat(e, "/").concat(t));
      };
    n(24);
    var N = function N(_ref4) {
      var e = _ref4.title,
        t = _ref4.description,
        n = _ref4.onRetryClick,
        _ref4$colorwayType = _ref4.colorwayType,
        r = _ref4$colorwayType === void 0 ? 4 : _ref4$colorwayType,
        _ref4$iconName = _ref4.iconName,
        a = _ref4$iconName === void 0 ? "cw-empty-search" : _ref4$iconName;
      return l.a.createElement(d.Div, {
        className: "insights--no-results-container"
      }, l.a.createElement(d.Colorway, {
        type: r
      }, l.a.createElement(f.Icon, {
        name: a
      })), l.a.createElement(d.H4, null, e), t && l.a.createElement(d.P, null, t), n && l.a.createElement(d.A, {
        onClick: n
      }, "Refresh"));
    };
    var j = A.access.isAdmin,
      T = A.access.hasGates,
      I = A.access.hasFeatures,
      D = function D() {
        return T("premium_enterprise", "enterprise_04_2018");
      },
      M = function M() {
        return j() || I({
          featureName: "convo_view_all",
          accessLevel: "READ"
        });
      };
    n(26);
    var P = function P(_ref5) {
      var e = _ref5.message,
        t = _ref5.keywords,
        n = _ref5.convoMeta;
      var r = e.author,
        a = e.basic;
      return l.a.createElement(d.Div, {
        className: "convo-detail-message-item-container"
      }, function () {
        var e = Object(s.path)(["company", "logo"], n);
        return "CUSTOMER" === r.type && e && "null" !== e ? l.a.createElement("img", {
          className: "convo-detail--company-logo",
          src: e,
          alt: ""
        }) : l.a.createElement(d.Avatar, {
          user: {
            id: miniHash(r.email || r.name || "Site visitor", !0),
            name: r.name || "Site visitor",
            email: r.email
          }
        });
      }(), l.a.createElement(d.Div, {
        className: "convo-detail-message-item-contents"
      }, l.a.createElement(d.Div, {
        className: "convo-detail-message-item-name-time"
      }, l.a.createElement(d.H4, {
        className: "convo-detail-message-item-name"
      }, r.name || r.email || "Site visitor"), l.a.createElement(d.P, {
        type: "small"
      }, i()(a.createdAt).format("LT \n\u2022 M/DD/YY"))), l.a.createElement(g, {
        message: e,
        keywords: t
      })));
    };
    n(28);
    var q = function q(_ref6) {
      var e = _ref6.conversationId,
        t = _ref6.orgId,
        n = _ref6.closeSidebar;
      var r = _slicedToArray(Object(c.useState)(), 2),
        o = r[0],
        i = r[1],
        u = _slicedToArray(Object(c.useState)(!1), 2),
        m = u[0],
        p = u[1],
        g = M();
      Object(c.useEffect)(function () {
        Object(s.isNil)(e) || Object(s.isNil)(t) || function () {
          var n = _asyncToGenerator(a.a.mark(function _callee() {
            var n, r;
            return a.a.wrap(function _callee$(a) {
              for (;;) {
                switch (a.prev = a.next) {
                  case 0:
                    return p(!0), a.prev = 1, a.next = 4, O(t, e);
                  case 4:
                    n = a.sent, r = n.data, i(r), a.next = 12;
                    break;
                  case 9:
                    a.prev = 9, a.t0 = a.catch(1), A.logger.logError(a.t0);
                  case 12:
                    return a.prev = 12, p(!1), a.finish(12);
                  case 15:
                  case "end":
                    return a.stop();
                }
              }
            }, _callee, null, [[1, 9, 12, 15]]);
          }));
          return function doFetchConversation() {
            return n.apply(this, arguments);
          };
        }()();
      }, [e, t]);
      var h = Object(c.useMemo)(function () {
        return o ? o.customer.employmentTitle && o.meta && o.meta.company && o.meta.company.name ? "".concat(o.customer.employmentTitle, " at ").concat(o.meta.company.name) : o.customer.employmentTitle ? o.customer.employmentTitle : o.meta && o.meta.company && o.meta.company.name ? o.meta.company.name : "" : "";
      }, [o]);
      return m ? l.a.createElement(d.CircleLoader, {
        size: "large",
        className: "new-conversation-detail--loading-spinner"
      }) : l.a.createElement(d.Div, {
        className: "new-conversation-detail"
      }, o ? l.a.createElement(d.Div, {
        className: "new-conversation-detail--conversation-container"
      }, l.a.createElement(d.Div, {
        className: "new-conversation-detail--header"
      }, l.a.createElement(d.Div, {
        className: "new-conversation-detail--name-cql"
      }, l.a.createElement(d.H2, null, o.customer.name || o.customer.email || "Site visitor"), v(o.meta.cqlRating)), l.a.createElement(d.P, {
        type: "small"
      }, h)), l.a.createElement(d.Div, {
        className: "new-conversation-detail--message-container"
      }, o.messages.map(function (e) {
        return l.a.createElement(P, {
          key: e.basic.messageId,
          message: e,
          keywords: [],
          convoMeta: o.meta
        });
      })), l.a.createElement(d.Div, {
        className: "new-conversation-detail--button-container"
      }, g && l.a.createElement(d.A, {
        href: "".concat(window.location.origin, "/inboxes/").concat(o.meta.inboxId, "/conversations/").concat(e),
        target: "_blank"
      }, l.a.createElement(d.Button, {
        type: "secondary"
      }, "View in live chat")), l.a.createElement(d.Button, {
        type: "tertiary",
        onClick: n
      }, "Cancel"))) : l.a.createElement(d.Div, {
        className: "new-conversation-detail--no-conversation-container"
      }, l.a.createElement(d.Div, null, l.a.createElement(d.Div, {
        className: "conversation-not-found-colorways-container"
      }, l.a.createElement(d.Colorway, {
        className: "conversation-not-found-colorways"
      }, l.a.createElement(f.Icon, {
        name: "cw-empty-search"
      }))), l.a.createElement(d.H4, null, "Sorry, we couldn\u2019t load the selected conversation."), l.a.createElement(d.P, {
        type: "subtle"
      }, "Try refreshing the page", g ? " or clicking the button below to view the conversation in live chat." : "!"))));
    };
    n(30);
    var L = function L(e) {
      var t = e.startDate,
        n = e.endDate,
        r = e.query,
        o = void 0 === r ? {} : r,
        f = e.keywordSets,
        g = void 0 === f ? [] : f,
        h = e.pageSizes,
        y = e.mode,
        v = void 0 === y ? "list" : y,
        E = e.isDrawerModeOpen,
        C = void 0 !== E && E,
        w = e.drawerTitle,
        x = void 0 === w ? "Conversations" : w,
        _ = _objectWithoutProperties(e, ["startDate", "endDate", "query", "keywordSets", "pageSizes", "mode", "isDrawerModeOpen", "drawerTitle"]);
      var k = Object(u.useSelector)(function (e) {
          return e.user.orgId;
        }),
        B = Object(u.useSelector)(Object(s.pathOr)("America/New_York", ["embed", "configuration", "theme", "timezone"])),
        O = _slicedToArray(Object(c.useState)(_.pageIndex || 0), 2),
        j = O[0],
        I = O[1],
        M = _slicedToArray(Object(c.useState)(_.pageSize ? _.pageSize : h && !Object(s.isEmpty)(h) ? h[0] : 25), 2),
        P = M[0],
        L = M[1],
        R = _slicedToArray(Object(c.useState)(1), 2),
        G = R[0],
        F = R[1],
        H = _slicedToArray(Object(c.useState)(), 2),
        U = H[0],
        Y = H[1],
        z = _slicedToArray(Object(c.useState)(!0), 2),
        W = z[0],
        V = z[1],
        Q = _slicedToArray(Object(c.useState)(!1), 2),
        K = Q[0],
        X = Q[1],
        J = _slicedToArray(Object(c.useState)([]), 2),
        Z = J[0],
        $ = J[1],
        ee = function () {
          var e = _asyncToGenerator(a.a.mark(function _callee() {
            var e, r, i, s, c;
            return a.a.wrap(function _callee$(a) {
              for (;;) {
                switch (a.prev = a.next) {
                  case 0:
                    return e = buildQuery(g, o), a.prev = 1, V(!0), X(!1), a.next = 6, S(k, B, e, P, j * P, t, n);
                  case 6:
                    r = a.sent, i = r.data, s = i.results, c = i.totalCount, $(s), F(Math.ceil(c / P)), a.next = 18;
                    break;
                  case 14:
                    a.prev = 14, a.t0 = a.catch(1), A.logger.logError(a.t0), X(!0);
                  case 18:
                    return a.prev = 18, V(!1), a.finish(18);
                  case 21:
                  case "end":
                    return a.stop();
                }
              }
            }, _callee, null, [[1, 14, 18, 21]]);
          }));
          return function fetchData() {
            return e.apply(this, arguments);
          };
        }();
      m(function () {
        t && n && ee();
      }, [P, j, t, n]);
      var te = "list" === v,
        ne = function ne() {
          var e = !Z || Object(s.isEmpty)(Z);
          if (e && W) return l.a.createElement(d.CircleLoader, {
            className: "insights--conversations-loader"
          });
          if (K) return l.a.createElement(N, {
            title: "There was an error fetching conversations",
            onRetryClick: ee
          });
          if (e) {
            if (function (e, t) {
              var n = D() ? i()().startOf("day").subtract(1, "year") : i()().startOf("day").subtract(60, "days");
              return e.isBefore(n) || t.isBefore(n);
            }(t, n)) {
              var _e = "With the ".concat(T("enterprise_04_2018") ? "Enterprise" : T("premium_enterprise") ? "Premium" : T("premium_team") ? "Pro" : T("premium_drift") ? "Standard" : "Free", " plan, you can see conversations\n          that are up to ").concat(D() ? "12 months" : "60 days", " old");
              return l.a.createElement(N, {
                iconName: "csv-error",
                colorwayType: 3,
                title: "Adjust your date range to view conversations",
                description: _e
              });
            }
            return l.a.createElement(N, {
              title: "There are no conversations that match your search",
              description: "Try adjusting your filters or date range to see more results!"
            });
          }
          var r = (te || !U) && l.a.createElement(b, {
              keywords: buildQuery(g, o),
              results: Z,
              setSelectedConversation: Y
            }),
            a = l.a.createElement(p.Paginator, {
              className: "results-list--paginator",
              totalPages: G,
              changeSize: function changeSize(e) {
                I(0), L(e.value);
              },
              index: j,
              size: P,
              sizes: h,
              goForward: function goForward() {
                return I(j + 1);
              },
              goBackward: function goBackward() {
                return I(j - 1);
              },
              position: "static"
            }),
            c = function c() {
              return Y(null);
            },
            u = !te || U ? l.a.createElement(q, {
              conversationId: U,
              orgId: k,
              closeSidebar: c
            }) : null;
          return te ? l.a.createElement(l.a.Fragment, null, r, a, l.a.createElement(d.Sidebar, {
            isOpen: U,
            title: "Details",
            hideOverlay: !0,
            toggleWidget: !0,
            close: c,
            className: "insights--conversations-drawer-container"
          }, l.a.createElement(d.Div, {
            className: "insights--drawer-content"
          }, u))) : U ? u : l.a.createElement(d.Div, {
            className: "insights--drawer-content-results"
          }, r, a);
        };
      return te ? l.a.createElement(d.Div, {
        className: "insights--conversations-container"
      }, ne()) : l.a.createElement(d.Sidebar, {
        isOpen: C,
        title: x,
        hideOverlay: !0,
        toggleWidget: !0,
        close: _.onDrawerClosePress,
        className: "insights--conversations-drawer-container"
      }, l.a.createElement(d.Div, {
        className: "insights--drawer-content"
      }, ne()));
    };
    n.d(t, "InsightsConversations", function () {
      return L;
    });
  }]);
});